import React from 'react';
import { motion } from 'framer-motion';
export function OpeningLead() {
  return <section className="py-20 px-4 bg-[#0B0E13] text-[#F5F0E8] border-b border-[#1A1F2E]" data-id="element-154">
      <div className="max-w-3xl mx-auto text-center md:text-left" data-id="element-155">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="space-y-8 text-lg md:text-xl leading-relaxed text-[#8B8578]" data-id="element-156">
          <p data-id="element-157">
            Hay un momento en casi todas las compras donde te das cuenta de
            algo:
          </p>

          <h2 className="text-2xl md:text-3xl font-serif font-bold text-[#F5F0E8] border-l-4 border-[#D4A843] pl-6 py-2" data-id="element-158">
            No estás comprando una casa. <br data-id="element-159" />
            Estás sobreviviendo un proceso.
          </h2>

          <p data-id="element-160">Un día es “todo bien”.</p>

          <p data-id="element-161">
            Al siguiente: el cash‑to‑close cambió, el CD trae números raros, y
            alguien menciona un deadline como si tú debieras haberlo sabido
            desde siempre.
          </p>

          <p data-id="element-162">
            Y ahí es cuando aparece el pensamiento que nadie dice en voz alta:
          </p>

          <div className="bg-[#1A1F2E] p-6 rounded-xl border border-[#D4A843]/20 text-center shadow-lg" data-id="element-163">
            <p className="text-xl md:text-2xl font-serif font-bold text-white italic" data-id="element-164">
              “¿Y si pierdo mi depósito por no entender algo?”
            </p>
          </div>

          <p data-id="element-165">
            Este kit existe para eso. No para “aprender real estate”. <br data-id="element-166" />
            <span className="text-[#D4A843] font-bold" data-id="element-167">
              Para no perder dinero por confusión.
            </span>
          </p>
        </motion.div>
      </div>
    </section>;
}